import { Component, OnInit, ChangeDetectorRef, AfterContentChecked, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { IItem } from '@coreui/angular-pro'
import { RestService } from 'src/app/services/rest/rest.service';
import { GenericResponse, RetailCustomerList, RetailClientClassificationList } from 'src/app/interfaces/apiresponses'; 
import { DatePipe } from '@angular/common';
import * as _ from 'lodash';

interface GetDocumentData {
  id: number;
  documentTypeId?: number;
  documentTypeName: string;
  documentName: string;
  base64Data: string;
}

@Component({

  selector: 'app-retail-client-classification',
  templateUrl: './retail-clientClassification.component.html',
  styleUrls: ['./retail-clientClassification.component.scss'],
  providers:[DatePipe]

})
export class RetailClientClassificationComponent {
  selectedItem: any
  
  RetailCustomers: any = []
  RetailCustomerTable: any = []
  columns = [
       {
      key: 'createdOn',
      label: 'Classification Date',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'userId',
      label: 'User Id',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'cif',
      label: 'CIF',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'name',
      label: 'Customer Name',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'clientCategoryOffered',
      label: 'Client Classification (System Generated)',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'clientCategory',
      label: 'Client Classification (Customer Accepted)',
      _cellProps: { align: 'middle' },
      filter: true
    },
   
    {
      key: 'raisedBy',
      label: 'Action',
      filter: false
    },
  ];
  getRowValueData: any;
  userForm!: FormGroup;
  showUserForm = false;
  selectedUser: any;
  documents: GetDocumentData[] = [];
  kycDocs : GetDocumentData[] = [];
  networthDocs : GetDocumentData[] = [];
  incomeDocs : GetDocumentData[] = [];
  addressDocs : GetDocumentData[] = [];
  raisedUserId!: string;
  documentGroups: any[] = [];

  constructor(private restApi: RestService,private datePipe: DatePipe) {}
  
  ngOnInit() {
    this.getRetailCustomerList();
  }
  getRetailCustomerList(){
    this.restApi.getClientClasificationslist().subscribe({
      next:(v:RetailClientClassificationList)=>{
        if(v.success) {

          // Populate the Id column in the data
          this.RetailCustomerTable = v.retailCustomers.map((item, id) => ({
            ...item            
            //,_selected: this.selectedItems.includes(id)
          }));

          // Dynamically generate columns, excluding the 'Id' column
          // if (v.retailCustomers.length > 0) {
          //   this.columns = Object.keys(v.retailCustomers[0])
          //     .filter(key => key !== 'id')        
          //     .map(key => ({
          //      key: key,
          //      label: key.charAt(0).toUpperCase() + key.slice(1)
          //     }));
          // }

        };
      },
      error:(e)=>{
        var ee = e;
            }
    })
  }

  
    viewClassification(rowData: any) {
  
    this.raisedUserId = rowData.userId;

    this.restApi.getClientClasificationCustomersDetails(rowData.userId).subscribe(
      (userData: any) => {
        if (userData) {

          this.userForm = new FormGroup({
            customerCIF: new FormControl(userData.cif || ''),
            customerName: new FormControl(userData.fullName || ''),
            clientCategory: new FormControl(userData.clientCategory || ''),
            netAssets: new FormControl(userData.netAssets || ''),
            employmentType: new FormControl(userData.employmentType || ''),
            primaryIncomeRange: new FormControl(userData.primaryIncomeRange || ''),
            otherIncomeRange: new FormControl(userData.otherIncomeRange || ''),
          });

           // Optionally store documents
          this.kycDocs = userData.kyc || [];
          this.networthDocs = userData.networth || [];
          this.incomeDocs = userData.income || [];
          this.addressDocs = userData.address || [];

           this.documentGroups = [
            { label: 'KYC Documents', docs: this.kycDocs || [] },
            { label: 'Net Worth Documents', docs: this.networthDocs || [] },
            { label: 'Income Documents', docs: this.incomeDocs || [] },
            { label: 'Address Documents', docs: this.addressDocs || [] },
          ];

          // this.kycDocs = userData.kyc || [];
          // this.networthDocs = userData.networth || [];
          // this.incomeDocs = userData.income || [];
          // this.addressDocs = userData.address || [];

          this.showUserForm = true;

          
          // this.documents = userData.documents;

        }
      },
      (error) => {
        console.error('Error fetching user data:', error);
      });
      // this.router.navigate(['/home/supportcomplaints/update-status', id.requestId]);
    }


    getFileIconClass(filename: string): string {
      const extension = filename?.split('.').pop()?.toLowerCase();

      switch (extension) {
        case 'pdf':
          return 'fas fa-file-pdf text-danger';
        case 'doc':
        case 'docx':
          return 'fas fa-file-word text-primary';
        case 'xls':
        case 'xlsx':
          return 'fas fa-file-excel text-success';
        case 'jpg':
        case 'jpeg':
        case 'png':
          return 'fas fa-file-image text-warning';
        case 'txt':
          return 'fas fa-file-alt text-muted';
        default:
          return 'fas fa-file text-secondary';
      }
    }

truncateFileName(filename: string, startChars: number = 12, endChars: number = 10): string {
  if (!filename) return '';
  if (filename.length <= startChars + endChars + 3) return filename;

  const start = filename.substring(0, startChars);
  const end = filename.substring(filename.length - endChars);
  return `${start}...${end}`;
}

  downloadDocument(documentData: GetDocumentData) {
    const byteCharacters = atob(documentData.base64Data);
    const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray]);

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentData.documentName;
    link.click();
  }

  resetForm() {
    this.showUserForm = false;
  }

  onUserFormSaveClick() {
    if (this.userForm.valid) {
      const formData = {
        userID: this.raisedUserId,
        fullName: this.userForm.get('customerName')?.value || '',
        email: this.userForm.get('customerEmail')?.value || '',
        mobile: this.userForm.get('customerMobile')?.value || '',
        clientCategory: this.userForm.get('clientCategory')?.value || ''
      };

      this.restApi.postUserFormData(formData).subscribe({
        next: (response) => {
          console.log('User form saved successfully:', response);
          alert('User data saved successfully!');
          this.showUserForm = false;
        },
        error: (error) => {
          console.error('Error saving user data:', error);
        }
      });
    } else {
      alert('Please fill in all required fields.');
    }
  }

  rowSelected(event: any) {}
}
